import { ITransferFormFieldPath } from '@app/shared/types';

const TRANSFER_FORM_FIELD_PATHS: ITransferFormFieldPath = {
  isChargeable: 'is_chargeable',
  count: 'count',
  eventId: 'event_id',
  glAccountName: 'gl_account.name',
  initialCount: 'initial_count',
  inventoryItemVenues: 'inventory_items',
  itemCost: 'item_cost',
  measureEntityId: 'measure_entity_id',
  measureFactorValue: 'measure_factor_value',
  siteId: 'site_id',
  siteIdTo: 'site_id_to',
  siteName: 'site_name',
  siteNameTo: 'site_name_to',
  status: 'status',
  storeNumber: 'store_number',
  storeNumberTo: 'store_number_to',
  totalCost: 'total_cost',
  category: 'category',
  quantityReversed: 'quantity_reversed',
  reversedCost: 'reversed_cost',
  receivedTotalCost: 'received_total_cost',
  transactionDate: 'transaction_date',
  transferType: 'transfer_type',
  type: 'type',
  departmentCodeTo: 'site_department_code_to',
  virtualInventoryItemVenues: 'virtual.inventory_items',
  virtualTotals: 'virtual.totals',
  virtualTransactionDate: 'virtual.transaction_date',
  transferGroupName: 'virtual.transfer_group_name',
  virtualReallyChangedTransfers: 'virtual.really_changed_transfers',
  par_qty: 'par_qty',
  source: 'source',
  is_send: 'is_send',
};

export { TRANSFER_FORM_FIELD_PATHS };
